import moment from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import ChartComponent from "react-chartjs-2";

const SrlChargerGraphTimeLine = (props) => {
  const { params, data: rawData, codes } = props;
  const [data, setData] = useState();
  const [options, setOptions] = useState();
  const chartRef = useRef(null);

  const colors = [
    {
      backgroundColor: "rgba(45, 159, 54, 0.4)",
      borderColor: "rgba(45, 159, 54, 1)",
      fontColor: "rgba(45, 159, 54, 1)",
    },
    {
      backgroundColor: "rgba(255, 128, 0, 0.8)",
      borderColor: "rgba(255, 128, 0, 1)",
      fontColor: "rgb(255, 128, 0)",
    },
  ];

  useEffect(() => {
    if (rawData && codes && params) {
      var options = {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              type: "time",
              // bounds: "ticks",
              time: {
                unit: "hour",
                minUnit: "minute",
                round: "minute",
                tooltipFormat: "Do MMM ha",
                displayFormats: {
                  day: "Do MMM",
                  hour: "ha",
                },
              },
              title: {
                display: true,
                text: "Date",
              },
              ticks: {
                display: true,
                autoSkip: true, // Skip ticks to avoid overlapping
                min: params.startDate,
                max: params.endDate,
                padding: 5,
                major: {
                  enabled: true,
                  display: true,
                  fontColor: "#000",
                  fontStyle: "bold",
                },
                minor: {
                  display: true,
                },
              },
            },
          ],
          yAxes: [],
        },
      };

      var data = {
        datasets: [],
      };

      codes.forEach((codeValue, codeIndex) => {
        // Check each instance to find the code
        rawData.instanceGraphs?.forEach((instance /*, instanceIndex*/) => {
          if (!(instance.records && instance.records.meta)) return;

          let metaEntry = Object.entries(instance.records?.meta).find((v) => {
            return v[1].code === codeValue;
          });

          if (metaEntry) {
            let metaIndex = metaEntry[0];
            let meta = metaEntry[1];

            let metaCode = meta.code;
            let timeValues = instance.records.data[metaIndex];

            let diagnosticRecord = rawData.diagnostics?.records?.find(
              (v) => v.code === codeValue
            );
            let categories = diagnosticRecord?.dataAttributeEnumValues?.map(
              (v) => {
                return v.nameEnum;
              }
            );

            data.datasets.push({
              yAxisID: codeValue,
              type: "line",
              label: diagnosticRecord?.description ?? metaCode,
              data: timeValues.map((timeValue) => {
                let tIndex = timeValue[0];
                let tValue = timeValue[1];

                let value = tValue;
                if (categories) {
                  let categoryIndex =
                    diagnosticRecord?.dataAttributeEnumValues.findIndex((v) => {
                      return v.valueEnum === value;
                    });
                  if (categoryIndex) {
                    value = categoryIndex;
                  }
                }

                return {
                  x: moment.unix(parseInt(tIndex)),
                  y: value,
                };
              }),
              lineTension: 0,
              backgroundColor:
                colors[codeIndex % colors.length].backgroundColor,
              borderColor: colors[codeIndex % colors.length].backgroundColor,
              pointRadius: 3,
              pointStyle: "crossRot",
              fill: false,
            });

            if (categories) {
              options.scales.yAxes.push({
                id: codeValue,
                type: "category",
                labels: categories,
                position: codeIndex % 2 === 0 ? "left" : "right",
                title: {
                  display: true,
                  text: "Level",
                },
                ticks: {
                  autoSkip: false,
                  reverse: categories ? true : false,
                  fontColor: colors[codeIndex % colors.length].fontColor,
                },
              });
            } else {
              const yValues = timeValues.map((timeValue) => timeValue[1]);
              const minY = Math.min(...yValues);
              const maxY = Math.max(...yValues);

              const suggestedMin = minY > 0 ? 0 : minY;
              const suggestedMax = maxY < 0 ? 0 : maxY;

              options.scales.yAxes.push({
                id: codeValue,
                type: "linear",
                position: codeIndex % 2 === 0 ? "left" : "right",
                ticks: {
                  suggestedMin: suggestedMin,
                  suggestedMax: suggestedMax,
                  autoSkip: true,
                  autoSkipPadding: 30,
                  fontColor: colors[codeIndex % colors.length].fontColor,
                  callback: function (value, index, values) {
                    return (
                      (value.toLocaleString && value.toLocaleString()) ??
                      (value.toString && value.toString()) ??
                      ""
                    );
                  },
                },
              });
            }
          }
        });
      });
      setOptions(options);
      setData(data);
    }
  }, [rawData]);

  return (
    <>
      {options && data ? (
        <ChartComponent
          ref={chartRef}
          data={data}
          options={options}
          type={"line"}
        />
      ) : (
        <Spinner animation="border" />
      )}
    </>
  );
};

export default SrlChargerGraphTimeLine;
